import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import Map from './Map';

function Footer() {
  return (
    <div className='footer-container'>
      <div className='footer-links'>
        <div className='footer-link-wrapper'>
          <div className='footer-link-items'>
            <h2>Find Us</h2>
            <a href="tel:+441233877878">Office: 01233 877878</a>
            <a href="tel:+447889630885">Mobile: 07889 630885</a>
            <a href="https://www.facebook.com/people/Sharen-Cain-FCCA/100069308291119/?locale=en_GB" target="_blank" rel="noopener noreferrer">
              <i className='fab fa-facebook-f' /> Facebook
            </a>
          </div>
          
          <div className='footer-map'>
            <Map />
          </div>

          <div className='footer-link-items'>
            <p className="address-text">24 The High Street,</p>
            <p className="address-text">Charing,</p>
            <p className="address-text">Ashford,</p>
            <p className="address-text">TN27 0HX</p>
          </div>

          <div className='footer-acca-container'>
            <img 
              src='/images/ACCA.png' 
              alt='ACCA Logo' 
              className='footer-acca-logo'
            />
          </div>
        </div>
      </div>
      <div className='footer-bottom'>
        <small className='website-rights'>SHAREN CAIN FCCA</small>
      </div>
    </div>
  );
}

export default Footer;